(function () {
    'use strict';

    angular.module("imApp").factory("vtService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3789,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3790,
                    parameters: edit
                });
            },
            translateAndPublish: function (edit) {
                return $ihttp.post({
                    method: 3799,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
